var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        {
          textAlignRight: !_vm.readOnly && _vm.editable,
          textAlignCenter: _vm.readOnly || !_vm.editable
        },
        "visibility-item",
        "verticalAlignTop",
        "iconContainer"
      ],
      on: {
        mouseenter: function($event) {
          _vm.active = _vm.isTouch ? _vm.active : true
        },
        mouseleave: function($event) {
          _vm.active = _vm.isTouch ? _vm.active : false
        },
        click: function($event) {
          _vm.active = _vm.isTouch ? !_vm.active : _vm.active
        }
      }
    },
    [
      _vm.readOnly || !_vm.editable
        ? _c("div", [_c("i", { class: _vm.getVisibilityClass() })])
        : _vm._e(),
      _vm._v(" "),
      !_vm.readOnly && _vm.editable
        ? _c("div", [
            _c("i", { class: _vm.getVisibilityClass() }),
            _c("i", { staticClass: "fa fa-caret-down" })
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.readOnly && _vm.editable && _vm.active
        ? _c("div", { staticClass: "openIconContainer" }, [
            _c("div", { staticStyle: { "margin-bottom": "10px" } }, [
              _c("i", { class: _vm.getVisibilityClass() }),
              _c("i", { staticClass: "fa fa-caret-up" })
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "clearfix chooseIconContainer",
                on: {
                  click: function($event) {
                    _vm.item.visibility = "PRIVATE"
                    _vm.active = false
                  }
                }
              },
              [
                _c("div", { staticClass: "checkContainer" }, [
                  _vm.item.visibility == "PRIVATE"
                    ? _c("i", { staticClass: "fa fa-check" })
                    : _c("span", [_vm._v(" ")])
                ]),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "textContainer" }, [_vm._v("Privat")])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "clearfix chooseIconContainer",
                on: {
                  click: function($event) {
                    _vm.item.visibility = "PUBLIC"
                    _vm.active = false
                  }
                }
              },
              [
                _c("div", { staticClass: "checkContainer" }, [
                  _vm.item.visibility == "PUBLIC"
                    ? _c("i", { staticClass: "fa fa-check" })
                    : _c("span", [_vm._v(" ")])
                ]),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "textContainer" }, [
                  _vm._v("Öffentlich")
                ])
              ]
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "iconInnerContainer" }, [
      _c("i", { staticClass: "fa fa-lock" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "iconInnerContainer" }, [
      _c("i", { staticClass: "fa fa-globe" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-35594d94", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35594d94","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProfileItemVisibilityEditor.vue
// module id = 528
// module chunks = 2